import Vue from 'vue'
import axios from '@/libs/axios'
const currentVersion =  Vue.prototype.$mainConfig.version
export default {
  namespaced: true,
  state: {
    version: currentVersion,
    currencyCode: null,
    currencySymbol: null,
    currencyLocaleMap: {
      USD: ['en-US', 'en-AU', 'en-CA'],
      EUR: ['de-DE', 'fr-FR', 'es-ES'],
      GBP: ['en-GB'],
      JPY: ['ja-JP'],
      CNY: ['zh-CN', 'zh-TW'],
      INR: ['en-IN', 'ta-IN'],
      TRY: ['tr-TR'],
      AUD: ['en-AU'],
      CAD: ['en-CA'],
      CHF: ['de-CH', 'fr-CH'],
      RUB: ['ru-RU']
    },
    portalRoutes: null,
    statusChecks: null,
    customerSources: null,
    logoURL: null,
    metaDataLoaded: false,
  },
  getters: {
    getVersion: state => {
      return state.version
    },
    getCurrencyCode: state => {
      return state.currencyCode
    },
    getCurrencySymbol: state => {
      return state.currencySymbol
    },
    getCurrencyLocaleMap: state => {
      return state.currencyLocaleMap
    },
    getPortalRoutes: state => {
      return state.portalRoutes
    },
    getStatusChecks: state => {
      return state.statusChecks
    },
    getCustomerSources: state => {
      return state.customerSources
    },
    getLogoURL: state => {
      return state.logoURL
    },
  },
  mutations: {
    setCurrency(state, currency) {
      state.currencyCode = currency.code
      state.currencySymbol = currency.currencySymbol
    },
    setPortalRoutes(state, routes) {
      state.portalRoutes = routes
    },
    setStatusChecks(state, checks) {
      state.statusChecks = checks
    },
    setCustomerSources(state, sources) {
      state.customerSources = sources
    },
    setLogoURL(state, url) {
      state.logoURL = url
    },
    setMetaDataLoaded(state, loaded) {
      state.metaDataLoaded = loaded
    },
  },
  actions: {
    async fetchCustomerMetaData({ commit, state }, force = false) {
      if (state.metaDataLoaded && !force) {
        return
      }
  
      try {
        const { data } = await Vue.prototype.$http.get('/global/metadata')
        
        if (data.currency) commit('setCurrency', data.currency)
        if (data.checkStatuses) commit('setStatusChecks', data.checkStatuses)
        if (data.sources) commit('setCustomerSources', data.sources)
        if (data.logoUrl) commit('setLogoURL', data.logoUrl)
  
        commit('setMetaDataLoaded', true)
        return data
      } catch (error) {
        console.error('Error fetching customer metadata:', error)
        throw error
      }
    }
    
  }
}
